import Component from '@ember/component';
import { computed, get } from '@ember/object';
import { service } from '@ember/service';

/*
  Either contactId or lineItem must be passed in

  attrs
  - contactId
  - lineItem 
*/
export default Component.extend({
  contactsCache: service(),

  contactId: null,
  lineItem: null,

  contact: computed('contactId', 'lineItem.id', function () {
    if (this.isAnonymous) {
      return null;
    }
    let contactId = this.contactId || get(this, 'lineItem.contactId');
    return this.contactsCache.getById(contactId);
  }),

  isAnonymous: computed('lineItem.anonymous', function () {
    return get(this, 'lineItem.anonymous') || false;
  }),
});
